import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';
import FormSection from './FormSection';
import { SemanticFormField } from './SemanticFormField';
import { getValidations } from '../helpers/validationByFieldType';

const age = process.env.REACT_APP_MINIMUM_AGE
  ? process.env.REACT_APP_MINIMUM_AGE
  : 21;
class FormGenerator extends PureComponent {
  static propTypes = {
    season: PropTypes.object,
    sections: PropTypes.object.isRequired,
    hexColorCodeC: PropTypes.string.isRequired,
    optionByField: PropTypes.object.isRequired,
    sectionsToRender: PropTypes.array.isRequired,
    ageConsent: PropTypes.bool,
  };
  static defaultProps = {
    ageConsent: false,
    season: {},
  };
  render() {
    const {
      sections,
      hexColorCodeC,
      optionByField,
      sectionsToRender,
      season,
    } = this.props;
    const minimumAgeC = season.minimumAgeC || age;
    return (
      <Form>
        {sectionsToRender.map((item, i) => (
          <FormSection
            key={i}
            name={item}
            sections={sections}
            hexColorCodeC={hexColorCodeC}
            optionByField={optionByField}
          />
        ))}
        {this.props.ageConsent && (
          <div style={{ marginBottom: '40px' }}>
            <Field
              name="ageConsent"
              label={`Ich bin ${minimumAgeC} Jahre oder älter.`}
              component={SemanticFormField}
              as={Form.Checkbox}
              validate={getValidations(true)}
            />
          </div>
        )}
      </Form>
    );
  }
}

export default reduxForm({ destroyOnUnmount: false})(FormGenerator);



// WEBPACK FOOTER //
// ./src/components/FormGenerator.js